import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MediaService {

    private mediaUpdate$ = new Subject<any>();


    constructor(
        private http: HttpClient
    ) { }


     // Add media
    addMedia(matchId, source, url) {
        return this.http.put<any>('api_endpoint' + '/match/add-media', { matchId, source, url });
    }

    // Remove media
    removeMedia(matchId, mediaId) {
        return this.http.put<any>('api_endpoint' + '/match/remove-media', { matchId, mediaId });
    }

    publishMediaUpdate(matchId, media) {
        this.mediaUpdate$.next({matchId, media});
    }

    subscribeMediaUpdate(): Observable<any> {
        return this.mediaUpdate$.asObservable();
    }

}
